const randFormat = new Intl.NumberFormat('en-ZA', {style: 'currency', currency: 'ZAR'});
const randFormatWithoutCents = new Intl.NumberFormat('en-ZA', {style: 'currency', currency: 'ZAR', maximumFractionDigits: 0});
const randFormatCompact = new Intl.NumberFormat('en-ZA', {style: 'currency', currency: 'ZAR', maximumFractionDigits: 0, notation: 'compact'});

const compactFormat = new Intl.NumberFormat('en', {notation: "compact"});
const ordinalNumberFormat = new Intl.PluralRules('en', {type: "ordinal"});
const numberFormatWithoutDecimals = new Intl.NumberFormat('en', {maximumFractionDigits: 0});

export function displayRandAmountWithDecimal(amount: number | null): string {
  if (amount) {
    return randFormat.format(amount);
  }
  return '-';
}

export function displayRandAmountWithoutDecimal(amount: number | null): string {
  if (amount) {
    return randFormatWithoutCents.format(amount);
  }
  return '-';
}

export function displayPercentageWithoutDecimal(amount: number | null): string {
  if (amount) {
    return numberFormatWithoutDecimals.format(amount) + '%';
  }
  return '-';
}
